import React from "react";
import {Spin} from "antd";

const ProductionLoader : React.FC = ({isPopoutVersion}) => {

    return (
        <>
            {
                isPopoutVersion ?
                    <>
                        <Spin className="table_spin"></Spin>
                        <p>Fetching NREL PV Watts Data...</p>
                    </>
                    :
                    <>
                        <p className={"sideBarLoaderMessage"}> <Spin/> Fetching NREL PV Watts Data...</p>
                    </>
            }
        </>
    )
}

export default ProductionLoader;